import React, { ChangeEvent, useCallback, useState } from 'react';
import { Grid } from '@material-ui/core';

import Complemento from '../Complemento';

import { useToast } from '../../../../../../../hooks/toast';
import { useRegisterAdded } from '../../../../../../../hooks/registerAdded';
import { useGrupoPizza } from '../../../../../../../hooks/grupoPizza';

import AcordeaoComplementos from '../AcordeaoComplementos';

import { SubmitButtonWrapper } from '../../../../styles';

import {
  ButtonAction,
  ComplementosStoredWrapper,
  DrawerTabTitle,
  HasComplementoWrapper,
  TabWrapper,
} from '../../../drawer_styles';

const Complementos: React.FC = () => {
  const { addToast } = useToast();
  const {
    handleSetHasGroupUpdated,
    handleSetHasProductUpdated,
  } = useRegisterAdded();
  const {
    grupoPizzaData,
    grupoPizzaId,
    resetDrawer,
    createNewGrupoPizza,
    updateGrupoPizza,
  } = useGrupoPizza();

  const [hasComplemento, setHasComplemento] = useState(() =>
    grupoPizzaData.complementos.length > 0 ? 'yes' : 'no',
  );

  const handleRadioBtnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setHasComplemento(e.target.value);
    },
    [],
  );

  const handleSubmit = useCallback(async () => {
    if (!hasComplemento) {
      addToast({
        type: 'error',
        title: 'Informe se o item tem complemento.',
      });

      return;
    }

    if (hasComplemento === 'yes' && grupoPizzaData.complementos.length < 0) {
      addToast({
        type: 'error',
        title: 'Erro ao criar o grupo',
        description: 'Você precisa criar pelo menos um complemento.',
      });

      return;
    }

    try {
      if (typeof grupoPizzaId === 'number') {
        addToast({
          type: 'info',
          title: 'Aguarde',
          description: 'Seu grupo está sendo editado.',
        });

        await updateGrupoPizza();

        addToast({
          type: 'success',
          title: 'Grupo editado com sucesso!',
        });
      } else {
        addToast({
          type: 'info',
          title: 'Aguarde',
          description: 'Seu grupo está sendo criado.',
        });

        await createNewGrupoPizza();

        addToast({
          type: 'success',
          title: 'Grupo criado com sucesso!',
        });
      }

      handleSetHasGroupUpdated(true);
      handleSetHasProductUpdated(true);
      resetDrawer();
    } catch (err) {
      if (typeof grupoPizzaId === 'number') {
        addToast({
          type: 'error',
          title: 'Erro ao editar o grupo',
          description:
            err.response?.data.message ||
            'Ocorreu um erro ao editar o grupo. Tente novamente.',
        });
      } else {
        addToast({
          type: 'error',
          title: 'Erro ao criar o grupo',
          description:
            err.response?.data.message ||
            'Ocorreu um erro ao criar o grupo. Tente novamente.',
        });
      }
    }
  }, [
    hasComplemento,
    grupoPizzaData,
    grupoPizzaId,
    addToast,
    resetDrawer,
    updateGrupoPizza,
    createNewGrupoPizza,
    handleSetHasGroupUpdated,
    handleSetHasProductUpdated,
  ]);

  return (
    <TabWrapper>
      <DrawerTabTitle>
        <h1>Complementos</h1>
        <span>Seu produto tem algum complemento? Adicione aqui :&#41;</span>
      </DrawerTabTitle>
      <div>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <HasComplementoWrapper>
              <div>
                <span>Selecione uma opção:</span>
                <form>
                  <label htmlFor="no_have">
                    <input
                      checked={hasComplemento === 'no'}
                      type="radio"
                      id="no_have"
                      name="has_complemento"
                      value="no"
                      onChange={handleRadioBtnChange}
                    />
                    Não, este produto não tem complemento
                  </label>

                  <label htmlFor="have">
                    <input
                      checked={hasComplemento === 'yes'}
                      type="radio"
                      id="have"
                      name="has_complemento"
                      value="yes"
                      onChange={handleRadioBtnChange}
                    />
                    Sim, este produto tem complemento
                  </label>
                </form>
              </div>
            </HasComplementoWrapper>
          </Grid>
          <Grid item xs={12}>
            <Complemento isEnabled={hasComplemento === 'yes'} />
          </Grid>
          {grupoPizzaData.complementos.length > 0 && hasComplemento === 'yes' && (
            <Grid item xs={12}>
              <ComplementosStoredWrapper>
                <h2>Grupos de complementos que compõem esse produto</h2>
              </ComplementosStoredWrapper>

              <AcordeaoComplementos />
            </Grid>
          )}
          <Grid item xs={12}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={resetDrawer}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="button"
                className="submit"
                onClick={handleSubmit}
              >
                Salvar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </div>
    </TabWrapper>
  );
};

export default Complementos;
